import {
  GET_USER_PROFILE_FAIL,
  GET_USER_PROFILE_REQUEST,
  GET_USER_PROFILE_SUCCESS,
  DEL_USER_PROFILE_FAIL,
  DEL_USER_PROFILE_REQUEST,
  DEL_USER_PROFILE_SUCCESS,
  GET_USER_PROFILES_FAIL,
  GET_USER_PROFILES_REQUEST,
  GET_USER_PROFILES_SUCCESS,
  ADD_USER_PROFILE_FAIL,
  ADD_USER_PROFILE_REQUEST,
  ADD_USER_PROFILE_SUCCESS
} from "./actions";

import { SIGN_OUT_SUCCESS } from "app/api/redux/Auth/actions";

import { IUserResponse } from "app/api/types";

interface IState {
  usersList: IUserResponse[];
  profile: IUserResponse;
  isLoading: boolean;
}
const initialState: IState = {
  usersList: [],
  profile: {
    email: "",
    name: "",
    username: ""
  },
  isLoading: false
};

const usersReducer = (
  state = initialState,
  action: { type: any; payload: any }
) => {
  switch (action.type) {
    case ADD_USER_PROFILE_REQUEST:
    case DEL_USER_PROFILE_REQUEST:
    case GET_USER_PROFILES_REQUEST:
    case GET_USER_PROFILE_REQUEST:
      return {
        ...state,
        isLoading: true
      };

    case ADD_USER_PROFILE_FAIL:
    case GET_USER_PROFILES_FAIL:
    case DEL_USER_PROFILE_FAIL:
    case GET_USER_PROFILE_FAIL:
      return {
        ...state,
        isLoading: false
      };

    case GET_USER_PROFILE_SUCCESS:
      return {
        ...state,
        profile: action.payload,
        isLoading: false
      };

    case GET_USER_PROFILES_SUCCESS:
      return {
        ...state,
        usersList: action.payload,
        isLoading: false
      };

    case ADD_USER_PROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false
      };

    case DEL_USER_PROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false
      };

    case SIGN_OUT_SUCCESS:
      return initialState;

    default:
      return state;
  }
};

export default usersReducer;
